import SumsubWebSdk from '@sumsub/websdk-react';
import { captureException } from '@sentry/react';
import { UseQueryResult } from '@tanstack/react-query';
import { ApiError } from '../../../../openapi';
import { useCallback } from 'react';
import { EventPayload, MessageHandler } from '@sumsub/websdk/types/types';
import { useTranslation } from 'react-i18next';
import { useAppearanceSetting } from '../../../../hooks/useThemeMode';

export function SumSubStep({
  tokenQuery,
  onSuccess,
}: {
  tokenQuery: UseQueryResult<string, ApiError>;
  onSuccess?: () => void;
}) {
  const { i18n } = useTranslation();
  const [theme] = useAppearanceSetting();
  const refreshToken = useCallback(
    () => tokenQuery.refetch().then((res) => res.data!),
    [tokenQuery],
  );

  const handleMessage: MessageHandler = (type, payload) => {
    switch (type) {
      case 'idCheck.applicantStatus': {
        const { reviewStatus } = payload as EventPayload<'idCheck.applicantStatus'>;
        if (reviewStatus !== 'init') {
          onSuccess?.();
        }
        break;
      }
      case 'idCheck.onApplicantStatusChanged': {
        const { reviewStatus } = payload as EventPayload<'idCheck.onApplicantStatusChanged'>;
        if (reviewStatus !== 'init') {
          onSuccess?.();
        }
        break;
      }
    }
  };

  if (!tokenQuery.data) {
    return null;
  }

  return (
    <SumsubWebSdk
      style={{ width: '100%', height: '100%' }}
      accessToken={tokenQuery.data}
      expirationHandler={refreshToken}
      options={{ adaptIframeHeight: true, enableScrollIntoView: true }}
      config={{
        theme,
        lang: i18n.language,
      }}
      onError={captureException}
      onMessage={handleMessage}
    />
  );
}
